// Utilitaires pour le calcul des frais de livraison

export const DELIVERY_CONFIG = {
  FREE_DELIVERY_THRESHOLD: 25,
  STANDARD_DELIVERY_FEE: 3.99,
  CURRENCY: 'EUR',
  CURRENCY_SYMBOL: '€'
};

/**
 * restaurantSettings: { delivery_fee?: number, minimum_order?: number }
 * minimum_order sert de seuil pour la livraison gratuite.
 * Si non fourni, les valeurs DELIVERY_CONFIG sont utilisées comme fallback.
 */
export const calculateDeliveryFee = (subtotal, cartItems = [], restaurantSettings = {}) => {
  if (cartItems.length === 0 || subtotal <= 0) return 0;

  const fee = restaurantSettings.delivery_fee != null
    ? Number(restaurantSettings.delivery_fee)
    : DELIVERY_CONFIG.STANDARD_DELIVERY_FEE;

  const threshold = restaurantSettings.minimum_order != null
    ? Number(restaurantSettings.minimum_order)
    : DELIVERY_CONFIG.FREE_DELIVERY_THRESHOLD;

  if (fee <= 0) return 0;
  if (threshold > 0 && subtotal >= threshold) return 0;

  return fee;
};

export const calculateFinalTotal = (subtotal, cartItems = [], restaurantSettings = {}) => {
  const deliveryFee = calculateDeliveryFee(subtotal, cartItems, restaurantSettings);
  const total = subtotal + deliveryFee;

  const threshold = restaurantSettings.minimum_order != null
    ? Number(restaurantSettings.minimum_order)
    : DELIVERY_CONFIG.FREE_DELIVERY_THRESHOLD;

  return {
    subtotal,
    deliveryFee,
    total,
    isFreeDelivery: deliveryFee === 0,
    remainingForFreeDelivery: Math.max(0, threshold - subtotal)
  };
};

export const getDeliveryInfo = (subtotal, cartItems = [], restaurantSettings = {}) => {
  const deliveryFee = calculateDeliveryFee(subtotal, cartItems, restaurantSettings);
  if (deliveryFee === 0) return null;

  const threshold = restaurantSettings.minimum_order != null
    ? Number(restaurantSettings.minimum_order)
    : DELIVERY_CONFIG.FREE_DELIVERY_THRESHOLD;

  const remaining = Math.max(0, threshold - subtotal);

  return {
    message: `Livraison gratuite à partir de ${threshold.toFixed(2)} € !`,
    remaining,
    remainingText: `Plus que ${remaining.toFixed(2)} € pour la livraison gratuite`
  };
};

export const validateDeliveryData = (subtotal, cartItems = []) => {
  if (typeof subtotal !== 'number' || isNaN(subtotal)) return false;
  if (!Array.isArray(cartItems)) return false;
  return true;
};

export default {
  calculateDeliveryFee,
  calculateFinalTotal,
  getDeliveryInfo,
  validateDeliveryData,
  DELIVERY_CONFIG
};
